import { Component, OnInit } from '@angular/core';
import { Building } from '../../building.model';
import { DataService } from 'src/app/service/buildings.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-building-list',
  templateUrl: './building-list.component.html',
  styleUrls: ['./building-list.component.css']
})
export class BuildingListComponent implements OnInit {

  buildings: Building[];
  building: any;
  empList: any;
  constructor(private dataService: DataService,private router: Router) { }


  getdata() {

    //console.log("data:", this.dataService.getBuildings().subscribe((data: Building[]) => { this.buildings = data; console.log("buildings:", this.buildings); }));

  //  return this.dataService.getBuildings().subscribe(data => { console.log("base emplist:", data); });//.subscribe(data => this.empList = data);  this.router.navigateByUrl("/buy")
  
  }

  ngOnInit() {

    this.getdata();

    //this.getbyid(5);
    // this.subscription = this.buildingsService.buildingsChanged
    //   .subscribe(
    //     (buildings: Building[]) => {
    //       this.buildings =this.empList;
    //     }
    //   );
    // this.buildings = this.empList;//this.buildingsService.getBuildings();
  }

  // onNewRecipe() {
  //   this.router.navigate(['new'], {relativeTo: this.route});
  // }

  ngOnDestroy() {
    //  this.subscription.unsubscribe();
  }

  getbyid(id) {


   
  }

  Edit(id) {

    
  }

  onDelete(id) {

    return this.dataService.deleteBuilding(id).subscribe(data => { console.log("delete:"); this.router.navigateByUrl("/getAll") });
 
  }

  upLoad(Data) {

    return this.dataService.updateBuilding(Data).subscribe(data => this.router.navigateByUrl("/buy"));
  
  }
}
